/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-06-23 22:27:32
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import history from 'src/routes/history';
import { routes } from 'src/routes';

type Props = {
  onDismiss: Function
};

type ComposedProps = Props & WithI18nProps;

class NoRangeSlider extends Component<ComposedProps> {
  render() {
    const { i18n } = this.props;
    return (
      <div className="noMetafield">
        <span style={{ color: 'red', fontWeight: 700 }}>
          {i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_HelperText_ImportantNOTE'
          )}
        </span>{' '}
        {i18n.translate('AdminHTML.FilterTree.Item.optionModal_GeneralTab_NoRangeSlider_Content', {
          t: (
            <Link
              onClick={() => {
                history.push(routes.customRangeSlider.view());
              }}>
              {i18n.translate(
                'AdminHTML.FilterTree.Item.optionModal_GeneralTab_NoRangeSlider_Content_t'
              )}
            </Link>
          )
        })}
      </div>
    );
  }
}

export default withI18n()(NoRangeSlider);
